/* eslint-disable */
import * as types from '../mutation-types';
import apiService from 'src/utils/apiService';

// initial state
const state = {
  tariffs: [],
  tariffPendingPayment: null,
  quotasInfo: null,
  currentTariff: null,
  futureTariff: null,
  tariffWillBeChangedAt: null,
};

// getters
const getters = {
};

// actions
const actions = {
  updateCurrentTariff({ commit }) {
    return apiService.getCurrentTariff().then((tariffsData) => {
      commit(types.UPDATE_CURRENT_TARIFF, tariffsData);
    });
  },
  updateTariffs({ commit }) {
    return apiService.getTariffs().then((tariffs) => {
      commit(types.UPDATE_TARIFFS, tariffs);
    });
  },
  updateQuotasInfo({commit }) {
    return apiService.getUserQuotasInfo().then((quotasInfo) => {
      commit(types.SET_USER_QUOTAS_INFO, quotasInfo);
    });
  },
  setTariffPendingPayment({ commit }, tariff) {
    commit(types.SET_TARIFF_PENDING_PAYMENT, tariff);
  },
};

// mutations
const mutations = {
  [types.UPDATE_CURRENT_TARIFF](s, tariffsData) {
    s.currentTariff = tariffsData.currentTariffPlan;
    s.futureTariff = tariffsData.futureTariffPlan;
    s.tariffWillBeChangedAt = tariffsData.tariffPlanWillBeChanged;
  },
  [types.UPDATE_TARIFFS](s, tariffs) {
    s.tariffs = tariffs;
  },
  [types.SET_TARIFF_PENDING_PAYMENT](s, tariff) {
    s.tariffPendingPayment = tariff;
  },
  [types.SET_USER_QUOTAS_INFO](s, quotasInfo) {
    s.quotasInfo = quotasInfo;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/subscription.js